export default __webpack_public_path__ + "static/media/homebanner.18adf558.jpg";